const ACTIONS = {
    TRIP_DETAILS_CHANGED: 'TRIP/DETAILS_CHANGED',
    UPDATE_TRIP_DETAILS: 'TRIP/UPDATE_TRIP_DETAILS',
    SET_BOOKING_FLOW: 'TRIP/SET_BOOKING_FLOW',
    TRIP_DETAILS_EDAP_CHECK: 'TRIP/EDAP_CHECK'
};

const ACTION_CREATORS = {
    tripDetailsChanged(fieldsChanged, isInitialPageLoad = false) {
        return {
            type: ACTIONS.TRIP_DETAILS_CHANGED,
            payload: {
                fieldsChanged,
                isInitialPageLoad
            }
        };
    },
    tripDetailsDataUpdated(fieldsChanged) {
        return {
            type: ACTIONS.UPDATE_TRIP_DETAILS,
            payload: {
                fieldsChanged
            }
        };
    },
    setBookingFlow(isBookingFlow) {
        return {
            type: ACTIONS.SET_BOOKING_FLOW,
            payload: {
                isBookingFlow
            }
        };
    },
    tripDetailsEdapCheck(tripDetails, dateValidity) {
        return {
            type: ACTIONS.TRIP_DETAILS_EDAP_CHECK,
            payload: {
                tripDetails,
                dateValidity
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
